import React, { useCallback } from "react";
import clsx from "clsx";
import * as auth from "../../../../lib/util/AuthUtils";
import { getUserDisplayName } from "../../../../lib/util/FormatUtils";
import MenuDropdown, {
	MenuDropdownProps,
	MenuItem,
} from "../../MenuDropdown/MenuDropdown";
import MenuTrigger from "../../MenuTrigger/MenuTrigger";
import { User } from "../../../../lib/types/UserTypes";

const routes = [
	{
		displayName: "%navigation_my_profile",
		id: "profile",
		pathName: "/profile",
	},
	{
		id: "debug",
		displayName: "Debug Menu",
		pathName: "/",
		noRedirect: true,
	},
	{
		displayName: "%navigation_sign_out",
		id: "signOut",
		pathName: "/",
		noRedirect: true,
	},
];

export interface NavUserProps {
	user: User | undefined | null;
	onRouteSelect: MenuDropdownProps["onSelect"];
}

const NavUser = (props: NavUserProps) => {
	const handleFilterItem = useCallback((item: MenuItem) => {
		return !(item.id === "debug" && !auth.isSuperAdmin());
	}, []);

	const { onRouteSelect, user } = props;

	const name = getUserDisplayName(user?.firstName, null, user?.uid, false);

	const heading = (
		<MenuTrigger className={"Navigation__user-trigger"}>
			<span>{name}</span>
		</MenuTrigger>
	);

	return (
		<MenuDropdown
			selected={
				(window.location.pathname.includes("profile") && "profile") || undefined
			}
			className={clsx("Navigation__user")}
			items={routes}
			onFilterItem={handleFilterItem}
			onSelect={onRouteSelect}
			tooltipClassName={"Navigation__user-menu"}
			overlay={true}
		>
			{heading}
		</MenuDropdown>
	);
};

export default NavUser;
